// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCkgQI72YdkVoXN8jDzqvloFNDsQtNdSTg",
  authDomain: "the-frosting-room.firebaseapp.com",
  projectId: "the-frosting-room",
  storageBucket: "the-frosting-room.firebasestorage.app",
  messagingSenderId: "1039455424197",
  appId: "1:1039455424197:web:68c14d92b7820ee7186aac",
  measurementId: "G-XJ62PLD6E4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and export it
export const analytics = getAnalytics(app);

// Initialize Storage and export it
export const storage = getStorage(app, 'gs://the-frosting-room.firebasestorage.app');

// Initialize Firestore and export it
export const db = getFirestore(app);

// Initialize Authentication and export it
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Export the app instance for use in other parts of the application
export default app;
